module.exports = __webpack_public_path__ + "img/laravel.b0ba6d0d.png";